import {GoogleOAuthProvider} from '@react-oauth/google';
export default GoogleOAuthProvider;
